import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Lo compré el lunes. El martes ya lo usé con un paciente nuevo de columna. No tuve que adaptar nada. Llegué a la sesión con un protocolo claro por primera vez.',
  author: 'Marcos T.',
  role: 'Kinesiólogo, Buenos Aires'
}, {
  quote: 'El Tomo de Adulto Mayor me cambió cómo trabajo los domicilios. Antes llegaba y evaluaba de memoria. Ahora tengo escalas, tests y un programa de ejercicio con evidencia real.',
  author: 'Sofía R.',
  role: 'Kinesióloga, Córdoba'
}, {
  quote: 'La calculadora de honorarios fue un golpe de realidad. Estaba cobrando menos de lo que me costaba atender. En una semana ajusté el precio y no perdí ningún paciente.',
  author: 'Ignacio P.',
  role: 'Kinesiólogo, Rosario'
}, {
  quote: 'Las fichas de ejercicios para pacientes me ahorran 40 minutos por día. Solo eso ya pagó el sistema en la primera semana.',
  author: 'Valentina M.',
  role: 'Kinesióloga, Mendoza'
}, {
  quote: 'Antes de tener el Mega Pack, pasaba horas armando planes de tratamiento que al final no me daban seguridad. Ahora tengo una estructura clara para cada paciente. Es un antes y un después para los que recién arrancamos.',
  author: 'Lucas G.',
  role: 'Kinesiólogo, La Plata'
}];
export function Testimonials() {
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-192">
      <div className="max-w-7xl mx-auto" data-id="element-193">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-charcoal text-center mb-16" data-id="element-194">
          Lo que dicen los que ya lo usan
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-195">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-brand-cream p-8 rounded-2xl border border-gray-100 flex flex-col h-full" data-id="element-196">
              <div className="flex gap-1 mb-4 text-brand-amber" data-id="element-197">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} fill="currentColor" data-id="element-198" />)}
              </div>
              <p className="text-gray-700 italic mb-6 flex-grow text-lg" data-id="element-199">
                "{t.quote}"
              </p>
              <div data-id="element-200">
                <p className="font-bold text-brand-charcoal" data-id="element-201">{t.author}</p>
                <p className="text-sm text-gray-500" data-id="element-202">{t.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}